export const IS_LOGGING_OUT_KEY = 'isLoggingOut';
export const LOGGING_OUT_VALUE = 'true';
